import { render, staticRenderFns } from "./topliva.vue?vue&type=template&id=1586cad5&scoped=true&"
import script from "./topliva.vue?vue&type=script&lang=js&"
export * from "./topliva.vue?vue&type=script&lang=js&"
import style0 from "./topliva.vue?vue&type=style&index=0&id=1586cad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1586cad5",
  null
  
)

export default component.exports